module.exports = __webpack_public_path__ + "static/media/rhodium-title.efc295f4.jpg";